import classNames from 'classnames';
import React from 'react';

export const SymbolicLinkOverLay: React.FC<{ error?: boolean }> = ({ error }) => (
  <div className={classNames('symbolic-link-overlay', { error: !!error })}></div>
);
